// ----------------------
// Constantes
// ----------------------

// Disable SAM
export const PUT_DISABLE_SAM = 'PUT_DISABLE_SAM';
export const PUT_DISABLE_SAM_SUCCESS = 'PUT_DISABLE_SAM_SUCCESS';
export const PUT_DISABLE_SAM_ERROR = 'PUT_DISABLE_SAM_ERROR';

// Disable WhiteList

// ----------------------
// Tipos
// ----------------------

export interface GenericState<T> {
  loading: boolean;
  data: T | null;
  error: string | null;
}

export interface Action<T = any> {
  type: string;
  payload?: T;
}

// ----------------------
// Estado inicial
// ----------------------

export const initialStatePutDisabledSam: GenericState<any> = {
  loading: false,
  data: null,
  error: null,
};

// ----------------------
// Reducer: disableSamRed
// ----------------------

export const putDisableSamRed = (
  state = initialStatePutDisabledSam,
  action: Action
): GenericState<any> => {
  switch (action.type) {
    case PUT_DISABLE_SAM:
      return { ...state, loading: true, error: null };
    case PUT_DISABLE_SAM_SUCCESS:
      return { ...state, loading: false, data: action.payload ?? null };
    case PUT_DISABLE_SAM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload ?? 'Error al deshabilitar el SAM',
      };
    default:
      return state;
  }
};
